import { ENVIRONMENT_CONFIG } from "shared/globals";

const apiBase = ENVIRONMENT_CONFIG.apiBase.endsWith("/")
  ? ENVIRONMENT_CONFIG.apiBase
  : ENVIRONMENT_CONFIG.apiBase + "/";
const permissionsApiBase = ENVIRONMENT_CONFIG.permissionsApiBase
  ? ENVIRONMENT_CONFIG.permissionsApiBase.endsWith("/")
    ? ENVIRONMENT_CONFIG.permissionsApiBase
    : ENVIRONMENT_CONFIG.permissionsApiBase + "/"
  : apiBase;

/**
 * Resolves relative URLs against API base URL. Returns absolute URLs as-is.
 *
 * @param {string} path - The path to resolve.
 */
export default function apiPath(path) {
  // Return absolute URLs as-is.
  if (/^https?:\/\//.test(path)) {
    return path;
  }

  // Append paths to the standard base URL.
  if (path.startsWith("/")) {
    path = path.slice(1);
  }

  const base = path.startsWith("permissions/") ? permissionsApiBase : apiBase;
  return base + path;
}
